// Common translations used across all pages (nav, footer, contact basics)
export const commonTranslations = {
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.benefits': 'Benefits',
    'nav.drivers': 'Benefits & Support',
    'nav.cadastro': 'Assisted Signup',
    'nav.registo': 'Register Yourself',
    'nav.requisitos': 'Check Eligibility',
    'nav.download': 'Download App',
    'nav.recarga': 'Top-Up',
    'nav.blog': 'Blog',
    'nav.sobreNos': 'About Us',
    'nav.coverage': 'Coverage',
    'nav.faq': 'FAQ',
    'nav.partners': 'Partners',
    'nav.contact': 'Contact',
    'nav.contactUs': 'Contact Us',
    'nav.testimonials': 'Testimonials',
    
    // Footer
    'footer.home': 'Home',
    'footer.about': 'About',
    'footer.blog': 'Blog',
    'footer.download': 'Download App',
    'footer.benefits': 'Benefits',
    'footer.services': 'Services',
    'footer.drivers': 'Driver Benefits',
    'footer.registo': 'Register Yourself',
    'footer.coverage': 'Coverage',
    'footer.faq': 'FAQ',
    'footer.partners': 'Partners',
    'footer.contact': 'Contact',
    'footer.testimonials': 'Testimonials',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms',
    'footer.language': 'Language',
    'footer.copyright': '© 2025 Kareem Taxi. All rights reserved.',
    'footer.viewOnGoogle': 'View us on Google',
    'footer.cadastro': 'Become a Driver',
    'footer.recarga': 'Automatic Top-Up',
    'footer.requisitos': 'Check Eligibility',
    'footer.sobreNos': 'About Us',
    'footer.shortAbout': 'Kareem Taxi is your trusted Yango partner in Maputo. Driver support, automatic payments, and 24/7 assistance.',
    'footer.shortAbout.home': 'Welcome to Kareem Taxi – your official Yango partner in Maputo. Fast driver activation, M-Pesa payments, and 24/7 support.',
    'footer.shortAbout.topup': 'Easy M-Pesa and eMola top-ups for Yango drivers. Kareem Taxi offers automatic weekly payments in Maputo.',
    'footer.shortAbout.registration': 'Fast Yango driver activation in Maputo. Kareem Taxi handles your registration with same-day approval.',
    'footer.shortAbout.cadastro': 'Get assisted Yango driver signup in Maputo. Kareem Taxi provides personalized support for account creation.',
    'footer.shortAbout.requirements': 'Check if you qualify for Yango in Mozambique. Kareem Taxi offers free eligibility verification.',
    'footer.shortAbout.requirementsPage': 'Review vehicle and document requirements for Yango drivers. Kareem Taxi guides you through the approval process.',
    'footer.shortAbout.blogIndex': 'Explore driver tips, earning guides, and success stories from Kareem Taxi – your official Yango partner in Maputo.',
    'footer.shortAbout.blog.1': 'Read practical driver tips from Kareem Taxi. Learn how to maximize your Yango earnings in Maputo.',
    'footer.shortAbout.blog.2': 'Discover earning strategies and local insights from Kareem Taxi, official Yango partner in Mozambique.',
    'footer.shortAbout.blog.3': 'Get expert advice for Yango drivers in Maputo. Kareem Taxi shares proven tips to increase your income.',
    'footer.shortAbout.blog.4': 'Stay informed with the latest driver guides from Kareem Taxi. Your trusted Yango partner in Maputo.',
    'footer.shortAbout.download': 'Download Yango Pro with Kareem Taxi support. Quick setup, instant activation, and technical assistance.',
    'footer.driversTitle': 'Drivers',
    'footer.companyTitle': 'Company',
    'footer.guidesTitle': 'Driver Guides',
    'footer.viewAllArticles': 'View All Articles',
    
    // Contact basics
    'contact.title': 'Contact Us',
    'contact.name': 'Name',
    'contact.email': 'Email',
    'contact.organization': 'Organization',
    'contact.subject': 'Subject',
    'contact.message': 'Message',
    'contact.submit': 'Send Message',
    'contact.success': 'Thanks! We\'ll reply by email.',
    'contact.emailLabel': 'Email',
    'contact.viewOnGoogle': 'View us on Google',
    
    // Partners
    'partners.title': 'Our Partners',
    'partners.subtitle': 'Partnerships build trust through results.',
    
    // 404 Page
    'notfound.intro': 'The page you are looking for does not exist or has been moved. Use the links below to find what you need:',
    'notfound.popularPages': 'Popular Pages',
    'notfound.searchSuggestion': 'If you are looking for information about Yango registration, driver requirements, or registration, explore the links above or contact our support team.',
    'notfound.needHelp': 'Need Help?',
    'notfound.contact': 'Contact our support team on WhatsApp',
  },
  pt: {
    // Navigation
    'nav.home': 'Início',
    'nav.about': 'Sobre',
    'nav.benefits': 'Benefícios',
    'nav.drivers': 'Benefícios & Suporte',
    'nav.cadastro': 'Cadastro Assistido',
    'nav.registo': 'Registar Online',
    'nav.requisitos': 'Verificar Elegibilidade',
    'nav.download': 'Baixar App',
    'nav.recarga': 'Recarga',
    'nav.blog': 'Blog',
    'nav.sobreNos': 'Sobre Nós',
    'nav.coverage': 'Cobertura',
    'nav.faq': 'Perguntas',
    'nav.partners': 'Parceiros',
    'nav.contact': 'Contacto',
    'nav.contactUs': 'Falar Connosco',
    'nav.testimonials': 'Depoimentos',
    
    // Footer
    'footer.home': 'Início',
    'footer.about': 'Sobre',
    'footer.blog': 'Blog',
    'footer.download': 'Baixar App',
    'footer.benefits': 'Benefícios',
    'footer.services': 'Serviços',
    'footer.drivers': 'Benefícios Motorista',
    'footer.registo': 'Registar Online',
    'footer.coverage': 'Cobertura',
    'footer.faq': 'Perguntas',
    'footer.partners': 'Parceiros',
    'footer.contact': 'Contacto',
    'footer.testimonials': 'Depoimentos',
    'footer.privacy': 'Política de Privacidade',
    'footer.terms': 'Termos',
    'footer.language': 'Idioma',
    'footer.copyright': '© 2025 Kareem Taxi. Todos os direitos reservados.',
    'footer.viewOnGoogle': 'Veja-nos no Google',
    'footer.cadastro': 'Tornar-se Motorista',
    'footer.recarga': 'Recarga Automática',
    'footer.requisitos': 'Verificar Elegibilidade',
    'footer.sobreNos': 'Sobre Nós',
    'footer.shortAbout': 'Kareem Taxi é seu parceiro Yango de confiança em Maputo. Suporte ao motorista, pagamentos automáticos e assistência 24/7.',
    'footer.shortAbout.home': 'Bem-vindo à Kareem Taxi – seu parceiro oficial Yango em Maputo. Ativação rápida, pagamentos M-Pesa e suporte 24/7.',
    'footer.shortAbout.topup': 'Recargas fáceis M-Pesa e eMola para motoristas Yango. A Kareem Taxi oferece pagamentos automáticos semanais em Maputo.',
    'footer.shortAbout.registration': 'Registe-se como motorista Yango em Maputo. A Kareem Taxi oferece suporte online para criar sua conta rapidamente.',
    'footer.shortAbout.cadastro': 'Cadastro assistido para motoristas Yango em Maputo. A Kareem Taxi cuida de todo o processo com aprovação no mesmo dia.',
    'footer.shortAbout.requirements': 'Verifique se qualifica para Yango em Moçambique. A Kareem Taxi oferece verificação gratuita de elegibilidade.',
    'footer.shortAbout.requirementsPage': 'Consulte os requisitos de veículo e documentos para motoristas Yango. A Kareem Taxi orienta você no processo de aprovação.',
    'footer.shortAbout.blogIndex': 'Explore dicas para motoristas, guias de ganhos e histórias de sucesso da Kareem Taxi – seu parceiro oficial Yango em Maputo.',
    'footer.shortAbout.blog.1': 'Leia dicas práticas para motoristas da Kareem Taxi. Aprenda a maximizar seus ganhos Yango em Maputo.',
    'footer.shortAbout.blog.2': 'Descubra estratégias de ganhos e insights locais da Kareem Taxi, parceiro oficial Yango em Moçambique.',
    'footer.shortAbout.blog.3': 'Obtenha conselhos especializados para motoristas Yango em Maputo. A Kareem Taxi partilha dicas comprovadas.',
    'footer.shortAbout.blog.4': 'Mantenha-se informado com os últimos guias da Kareem Taxi. Seu parceiro Yango de confiança em Maputo.',
    'footer.shortAbout.download': 'Baixe Yango Pro com suporte Kareem Taxi. Configuração rápida, ativação instantânea e assistência técnica.',
    'footer.driversTitle': 'Motoristas',
    'footer.companyTitle': 'Empresa',
    'footer.guidesTitle': 'Guias para Motoristas',
    'footer.viewAllArticles': 'Ver Todos os Artigos',
    
    // Contact basics
    'contact.title': 'Falar Connosco',
    'contact.name': 'Nome',
    'contact.email': 'Email',
    'contact.organization': 'Organização',
    'contact.subject': 'Assunto',
    'contact.message': 'Mensagem',
    'contact.submit': 'Enviar Mensagem',
    'contact.success': 'Obrigado! Responderemos por email.',
    'contact.emailLabel': 'Email',
    'contact.viewOnGoogle': 'Veja-nos no Google',
    
    // Partners
    'partners.title': 'Os Nossos Parceiros',
    'partners.subtitle': 'Parcerias constroem confiança através de resultados.',
    
    // 404 Page
    'notfound.intro': 'A página que procura não existe ou foi movida. Use os links abaixo para encontrar o que precisa:',
    'notfound.popularPages': 'Páginas Populares',
    'notfound.searchSuggestion': 'Se procura informações sobre cadastro Yango, registo motorista, ou requisitos, explore os links acima ou contacte a nossa equipa de suporte.',
    'notfound.needHelp': 'Precisa de Ajuda?',
    'notfound.contact': 'Contacte a nossa equipa de suporte no WhatsApp',
  }
};
